var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"copy_12 pfeil-btn text-link",class:{'vgh-blau-color': _vm.mandant === 1,
    'vgh-blau-text-decoration-hover': _vm.mandant === 1,
    'oesa-gruen-color': _vm.mandant === 3,
    'oesa-gruen-text-decoration-hover': _vm.mandant === 3,
    'oevo-blau-color': _vm.mandant === 5,
    'oevo-blau-text-decoration-hover': _vm.mandant === 5},attrs:{"id":"button"},on:{"click":_vm.zumLink}},[_c('em',{staticClass:"fa-solid fa-chevron-right pfeil"}),_vm._v(" "+_vm._s(_vm.buttonText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }